exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PureGreenButton {\n  display: block;\n  position: absolute;\n  transform: translateX(-50%); }\n  .PureGreenButton a {\n    cursor: pointer; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Buttons/PureGreenButton.scss
// module id = 172
// module chunks = 0